<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fas fa-4x fa-exchange-alt page-icon"></i>
			</div>

			<div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2" onclick="Anvil.page.searchModal()"><i class="fa fa-lg mb-2 fa-filter"></i><br />Szűrő<span id="filter-btn-badge" class="badge rounded-pill bg-danger ms-1 d-none"></span></button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3" onclick="Anvil.exec('transaction/modal_import');"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<!-- <button class="btn btn-success pl-3 pr-3 disabled"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button> -->
				</div>
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<ol class="breadcrumb mb-2">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item active">Pénzmozgások</li>
						</ol>

						<div class="float-end">
							<div class="row g-2">
								<div class="col-auto" style="width:300px; max-width:50vw;">
									<%- include('/ui/form', {
										params: [ 'search', search ],
										fields: [
											{
												type: 'text',
												inline: true,
												name: 'expression',
												title: 'Szöveges keresés',
												attributes: {
													placeholder: 'Keresés...'
												},
												append: '<span class="input-group-text"><i class="fa fa-search"></i></span>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto d-lg-none">
									<button id="filter-btn-2" class="btn btn-dark position-relative" onclick="Anvil.page.searchModal()"><i class="fa fa-fw fa-filter"></i><span id="filter-btn-badge-2" class="badge rounded-pill bg-danger position-absolute top-0 start-100 translate-middle d-none"></span></button>
								</div>
							</div>
						</div>
						<h2 class="pt-1">Pénzmozgások</h2>
					</div>

					<%- include('/ui/grid', {
						name: 'transaction',
						list: transactions,
						params: {
							row_height: 28.5,
							render_footer (list, map) {
								let total_expense = 0
								let total_income = 0
								let total_balance = 0
								for (let transaction of map) {
									if (transaction.amount > 0) {
										total_income += transaction.amount
									} else {
										total_expense += transaction.amount
									}
									total_balance += transaction.amount
								}
								return `Összes bevétel: <strong class="m-0 p-0" style="color:goldenrod;">${Anvil.numeral(total_income).format('0,0')} Ft</strong><span class="mx-2">|</span>Összes kiadás: <strong class="m-0 p-0" style="color:peru;">${Anvil.numeral(total_expense).format('0,0')} Ft</strong><span class="mx-2">|</span>Egyenleg: <strong class="m-0 p-0" style="color:white;">${Anvil.numeral(total_balance).format('0,0')} Ft</strong>`
							},
							columns: [
								{
									title: 'Elküldve',
									field: 'transaction_d',
									type: 'date',
									width: 100
								},
								{
									title: 'Könyvelve',
									field: 'complete_d',
									type: 'date',
									options: {
										class: 'text-dim'
									},
									width: 100
								},
								{
									title: 'Típus',
									field: 'type',
									type: 'string',
									options: {
										cutoff: 50
									},
									width: 240
								},
								{
									title: 'Összeg',
									field: 'amount',
									type: {
										render (value) {
											if (value > 0) {
												return '<div class="d-flex justify-content-between w-100"><i class="text-success fa fa-arrow-circle-left" style="margin-top:2px;"></i><strong style="color:goldenrod;">' + Anvil.numeral(value).format('0,0') + '</strong></div>'
											} else {
												return '<div class="d-flex justify-content-between w-100"><i class="text-warning fa fa-arrow-circle-right" style="margin-top:2px;"></i><strong style="color:peru;">' + Anvil.numeral(value).format('0,0') + '</strong></div>'
											}
										}
									},
									width: 120
								},
								{
									title: 'Küldő',
									field: 'sender',
									type: {
										render (value, row) {
											if (row.amount > 0) {
												return value
											} else {
												return `<span class="text-dim">${value}</span>`
											}
										}
									},
									width: 240
								},
								{
									title: 'Fogadó',
									field: 'receiver',
									type: {
										render (value, row) {
											if (row.amount > 0) {
												return `<span class="text-dim">${value}</span>`
											} else {
												return value
											}
										}
									},
									width: 230
								},
								{
									title: 'Bankszámla',
									field: 'ban',
									type: {
										render (value, row) {
											if (value) {
												const text = value.replace(/(.{8})/g, '$1-').slice(0, -1)
												const ban = Anvil.page.company_bans.getByBan(value)
												const link_btn = `<button class="btn btn-sm btn-dark py-0 mb-0 float-end" onclick="Anvil.page.link_ban('${value}', '${(row.amount > 0 ? row.sender.replaceAll('\'', '').replaceAll('\"', '') : row.receiver.replaceAll('\'', '').replaceAll('\"', ''))}');"><i class="fa fa-fw fa-link"></i></button>`
												if (ban) {
													const company = Anvil.page.companies.getById(ban.company_id)
													if (company) {
														return `<span class="text-primary">${text}</span>` + link_btn
													}
												}

												return `<span class="text-warning">${text}</span>` + link_btn
											}

											// Add dashes after every 8 characters
											return ''
										}
									},
									width: 230
								},
								{
									title: 'Swift',
									field: 'swift',
									type: 'string',
									width: 100
								},
								{
									title: 'Közlemény',
									field: 'remark',
									type: 'string',
									options: {
										cutoff: 250
									},
									width: 300
								},
								{
									title: 'Megj.',
									field: 'note',
									type: {
										render (value, row) {
											if (value) {
												return '<span class="text-info"><i class="fa fa-info-circle"></i></span>'
											}
											return ''
										}
									},
									options: {
										class: 'text-center'
									},
									width: 50
								},
								{
									title: 'Hiba',
									field: 'resolved',
									type: {
										render (value, row) {
											if (value == 0 && row.direction == 'income') {
												return '<span class="text-danger"><i class="fa fa-exclamation-triangle"></i></span>'
											} else if (value == 0 && row.direction == 'expense') {
												return '<span class="text-warning"><i class="fa fa-exclamation-triangle"></i></span>'
											} else {
												return '<span class="text-success"><i class="fa fa-circle-check"></i></span>'
											}
										}
									},
									options: {
										class: 'text-center'
									},
									width: 50
								}
							]
						}
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<button class="btn btn-success" onclick="Anvil.page.new('income')"><i class="fa fa-fw fa-plus"></i><span class="d-none d-md-inline ms-2">Új bevétel</span></button>
					<button class="btn btn-success" onclick="Anvil.page.new('expense')"><i class="fa fa-fw fa-plus"></i><span class="d-none d-md-inline ms-2">Új kiadás</span></button>
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-fw fa-edit"></i><span class="d-none d-md-inline ms-2">Megnyitás</span></button>
					<button class="btn btn-danger ml-2" onclick="Anvil.page.delete()"><i class="fa fa-fw fa-trash"></i><span class="d-none d-md-inline ms-2">Törlés</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	init () {
		Anvil.page.quickSearch()
	},

	searchModal () {
		Anvil.modal('/issue/page_list_search_modal', { search: Anvil.page.search })
	},

	quickSearch () {
		const filters = []
		const params = {
			sort_order: Anvil.page.search.sort_order
		}

		const expression = Anvil.page.search.expression
		if (expression) {
			params.expression = expression
		}

		if (filters.length > 0) {
			$('#filter-btn, #filter-btn-2').removeClass('btn-dark').addClass('btn-success')
			$('#filter-btn-badge, #filter-btn-badge-2').text(filters.length).removeClass('d-none')
		} else {
			$('#filter-btn, #filter-btn-2').removeClass('btn-success').addClass('btn-dark')
			$('#filter-btn-badge, #filter-btn-badge-2').text('').addClass('d-none')
		}

		// Generate URL
		window.history.replaceState({}, '', Anvil.href('/transaction/list', params))

		Anvil.models.components.Grid.find('#transaction_grid').filter(expression, filters)
	},

	refresh () {
		Anvil.exec('transaction/action_refresh')
	},

	link_ban (ban, name) {
		Anvil.exec('company_ban/modal_link_ban', ban, name)
	},

	new (direction) {
		Anvil.exec('transaction/modal_edit', null, direction)
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#transaction_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('transaction/modal_edit', sel[0].uuid)
		}
	},

	delete () {
		let sel = Anvil.models.components.Grid.find('#transaction_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('transaction/action_delete', sel[0].uuid)
		}
	}
})

$('#transaction_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
